import { render, staticRenderFns } from "./LmDocumentTypesNewOrEdit.vue?vue&type=template&id=37428f72&scoped=true&"
import script from "./LmDocumentTypesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmDocumentTypesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmDocumentTypesNewOrEdit.vue?vue&type=style&index=0&id=37428f72&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37428f72",
  null
  
)

export default component.exports